<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
          <div id="reporting" class="llp-container-section heightcontainer">
            <div
              class="container-fluid overflow-auto"
              style="padding-left:0px;padding-right:0px"
            >
              <nav class="navbar navbar-expand-lg bg-info text-white">
                <span>
                  <b>Customer Universal Search</b>
                </span>
              </nav>
              <p align="center" class="confirm-message">{{ message }}</p>

              <br />

              <div
                class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
              >
                <div
                  class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                >
                  <label class="col-form-label col-form-label-sm required"
                    >Customers</label
                  >
                </div>
                <div
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                >
                  <multiselect
                    style="width:100%"
                    v-model="selectedCustomerId"
                    :options="customersList"
                    placeholder="Select"
                    Customer
                    :value="customersList.customerId"
                    :custom-label="displayFullName"
                    selected="selected"
                    id="customersdd"
                    @input="getCustomerAppDetails()"
                  ></multiselect>
                </div>
                <div
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                >
                  <input type="checkbox" v-model="ischecked" class="mr-2" />Show
                  Fraud Details
                </div>
              </div>
              <br />
              <br />
              <nav class="navbar navbar-expand-lg bg-info text-white">
                <span>
                  <b>Customer Fraud Information</b>
                </span>
              </nav>

              <div
                class="row p-2 justify-content-center"
                style="overflow:auto;"
              >
                <div class="col">
                  <div class="table-responsive table-responsive-sm">
                    <table
                      id="dealerstable"
                      class="table table-sm table-bordered table-striped"
                    >
                      <thead>
                        <tr class="table-month-header-blue">
                          <th v-for="(col, index) in colheaders" :key="index">
                            <span>{{ col.header }}</span>
                          </th>
                        </tr>
                      </thead>
                      <tr
                        v-for="(customerfraud, index) in filterfraud"
                        :key="index"
                      >
                        <td class="table-month-td">
                          {{ customerfraud.firstName }}
                        </td>
                        <td class="table-month-td">
                          {{ customerfraud.middleName }}
                        </td>
                        <td class="table-month-td">
                          {{ customerfraud.lastName }}
                        </td>
                        <td class="table-month-td">
                          {{ customerfraud.businessName }}
                        </td>
                        <td class="table-month-td">
                          {{ customerfraud.fraudReason }}
                        </td>
                        <td class="table-month-td">
                          {{ customerfraud.customerFraudFlag }}
                        </td>
                        <td class="table-month-td">
                          {{ customerfraud.primaryPhoneNumber }}
                        </td>
                        <td class="table-month-td">
                          {{ customerfraud.primaryPhoneFraudFlag }}
                        </td>
                        <td class="table-month-td">
                          {{ customerfraud.status }}
                        </td>
                        <td class="table-month-td">
                          {{ customerfraud.updatedD }}
                        </td>
                        <td class="table-month-td">
                          {{ customerfraud.updatedUserId }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <nav class="navbar navbar-expand-lg bg-info text-white">
                <span>
                  <b>Quotes</b>
                </span>
              </nav>
              <div
                class="row p-2 justify-content-center"
                style="overflow:auto;"
              >
                <div class="col">
                  <div class="table-responsive table-responsive-sm">
                    <table class="table table-sm table-bordered table-striped">
                      <thead>
                        <tr class="table-month-header-blue">
                          <th v-for="head in heads">{{ head.name }}</th>
                        </tr>
                      </thead>
                      <tr v-for="(quote, index) in listQuotes" :key="index">
                        <td class="table-month-td">{{ quote.lmQuoteId }}</td>
                        <td class="table-month-td">
                          {{ quote.lmQuote | moment(MM / DD / YYYY) }}
                        </td>
                        <td class="table-month-td">
                          {{ quote.lmProposedLesseeName }}
                        </td>
                        <td class="table-month-td">
                          {{ quote.businessContactFullName }}
                        </td>
                        <td class="table-month-td">{{ quote.lmMake }}</td>
                        <td class="table-month-td">{{ quote.lmModel }}</td>
                        <td class="table-month-td">{{ quote.lmYear }}</td>
                        <td class="table-month-td">
                          {{ quote.lmQuoteStatus }}
                        </td>
                        <td class="table-month-td">{{ quote.lmLoanAmount }}</td>
                        <td class="table-month-td">{{ quote.lmDealerName }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <nav class="navbar navbar-expand-lg bg-info text-white">
                <span>
                  <b>Apps and Deals</b>
                </span>
              </nav>
              <div
                class="row p-2 justify-content-center"
                style="overflow:auto;"
              >
                <div class="col">
                  <div class="table-responsive table-responsive-sm">
                    <table
                      id="myQuotesTable"
                      class="table table-sm table-bordered table-striped"
                    >
                      <thead>
                        <tr class="table-month-header-blue">
                          <th v-for="head in appheaders">{{ head.name }}</th>
                        </tr>
                      </thead>
                      <tr v-for="(app, index) in listAppsDeals" :key="index">
                        <td class="table-month-td">
                          {{ app.appDate | moment(MM / DD / YYYY) }}
                        </td>
                        <td class="table-month-td">
                          {{ app.proposedLesseeName }}
                        </td>
                        <td class="table-month-td">
                          {{ app.businessContactFullName }}
                        </td>
                        <td class="table-month-td">{{ app.make }}</td>
                        <td class="table-month-td">{{ app.model }}</td>
                        <td class="table-month-td">{{ app.source }}</td>
                        <td class="table-month-td">{{ app.dealerName }}</td>
                        <td class="table-month-td">{{ app.appStatus }}</td>
                        <td class="table-month-td">
                          {{ app.appDeclineReason }}
                        </td>
                        <td class="table-month-td">{{ app.dealStatus }}</td>
                        <td class="table-month-td">
                          {{ app.fundedDate | moment(MM / DD / YYYY) }}
                        </td>
                        <td class="table-month-td">
                          {{ app.dealDeclineReason }}
                        </td>
                        <td class="table-month-td">{{ app.quoteState }}</td>
                        <td class="table-month-td">{{ app.quoteId }}</td>
                        <td class="table-month-td">{{ app.salesAgentName }}</td>
                        <td class="table-month-td">{{ app.loanAmount }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <bottom-footer></bottom-footer>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpcommon from '../js/http-common.js'
import httpcommonzero from '../js/http-common-zero.js'
import httpcustomer from '../js/http-customer.js'
import multiselectcss from '@/css/vue-multiselect.min.css'
import httpdeal from '../js/http-dealstracking.js'
import { bus } from '../main'
import { debug } from 'util'
export default {
  components: { MainMenu, TopHeader, BottomFooter, multiselectcss },
  data () {
    return {
      message: '',
      selectedCustomerId: '',
      customer: this.customerObject(),
      customerFraudHistory: [],
      customersList: [],
      ischecked: true,
      listAppsDeals: [],
      listQuotes: [],
      msgcolor: {
        color: 'black'
      },
      colheaders: [
        { header: 'First Name' },
        { header: 'Middle Name' },
        { header: 'Last Name' },
        { header: 'Business Name' },
        { header: 'Customer Fraud Reason' },
        { header: 'Customer Fraud Indicator' },
        { header: 'Primary Phone Number' },
        { header: 'Phone Fraud Flag' },
        { header: 'Customer Status' },
        { header: 'Updated Date' },
        { header: 'Updated By' }
      ],
      heads: [
        { name: 'Quote Number' },
        { name: 'Quote Date' },
        { name: 'Lessee Name' },
        { name: 'Bussiness Name' },
        { name: 'Make' },
        { name: 'Model' },
        { name: 'Year' },
        { name: 'Status' },
        { name: 'Loan Amount' },
        { name: 'Dealer Name' }
      ],
      appheaders: [
        { name: 'Application Date' },
        { name: 'Customer Name' },
        { name: 'Business Name' },
        { name: 'Make' },
        { name: 'Model' },
        { name: 'Source' },
        { name: 'Dealer Name' },
        { name: 'Application Status' },
        { name: 'App Decline Reason' },
        { name: 'Deal Status' },
        { name: 'Funded Date' },
        { name: 'Deal Decline Reason' },
        { name: 'App State' },
        { name: 'Quote Number' },
        { name: 'Salesperson Name' },
        { name: 'Loan Amount' }
      ]
    }
  },
  methods: {
    customerObject () {
      return {
        firstName: '',
        middleName: '',
        lastName: '',
        businessName: ''
      }
    },
    displayFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName} ${
          option.middleName != null && option.middleName.length != 0
            ? ',' + option.middleName
            : ''
        } ,${
          option.lastName != null && option.lastName.length != 0
            ? option.lastName
            : ''
        }`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },
    fetchData () {
      this.retrieveCustomerList()
    },
    retrieveCustomerList () {
      httpcustomer
        .get('/customer/getQuotesAppscustomerNames')
        .then(response => {
          this.customersList = response.data
        })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    getCustomerAppDetails () {
      this.getQuotes()
      this.getCustomerFraudHistory()
      this.getAppsDeals()
    },

    getCustomerFraudHistory () {
      httpcustomer
        .get(
          '/customer/getcustomerFraudAudit/?customerId=' +
            this.selectedCustomerId.customerId
        )
        .then(response => {
          this.customerFraudHistory = response.data
        })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    getQuotes () {
      httpdeal
        .get(
          '/quote/getQuotesUniversalSearch/?customerId=' +
            this.selectedCustomerId.customerId
        )
        .then(response => {
          this.listQuotes = response.data
        })
    },
    getAppsDeals () {
      httpdeal
        .get(
          '/application/getAppsDealsUniversalSearch/?customerId=' +
            this.selectedCustomerId.customerId
        )
        .then(response => {
          this.listAppsDeals = response.data
        })
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#reporting').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },
  computed: {
    filterfraud: function () {
      if (this.ischecked == true) {
        return this.customerFraudHistory.filter(customer => {
          return (
            customer.customerFraudFlag == 'Y' ||
            customer.primaryPhoneFraudFlag == 'Y'
          )
        })
      } else return this.customerFraudHistory
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped>
.maxwidth {
  max-width: 6%;
  margin-top: 10px;
}
.floatleft {
  float: left;
}
</style>
